/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Downloads_Macos_CtaInputs */

const en_downloads_macos_cta = /** @type {(inputs: Downloads_Macos_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Download for macOS`)
};

const es_downloads_macos_cta = /** @type {(inputs: Downloads_Macos_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Descargar para macOS`)
};

/**
* | output |
* | --- |
* | "Download for macOS" |
*
* @param {Downloads_Macos_CtaInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const downloads_macos_cta = /** @type {((inputs?: Downloads_Macos_CtaInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Downloads_Macos_CtaInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_downloads_macos_cta(inputs)
	return en_downloads_macos_cta(inputs)
});